// extracted by mini-css-extract-plugin
export default {"block":"Block_block__41bWx","image":"Block_image__dfLz6","texts":"Block_texts__Z5Q3+","title":"Block_title__mxLEc","article":"Block_article__hUUiY"};